@if (data) {
  <div class="detalles-header">
    <h3>{{ title }}</h3>
    <button
      irxBotonIcono
      (click)="onClose()"
      tooltip="Cerrar detalles"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <app-json-tree [data]="data"></app-json-tree>
}
